import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { Error } from "@mui/icons-material";
import { isMobile } from "./deviceUtils";
import './styles.css';
import { percentualPotenciaMinimoModulos } from "./checarPotenciaTotal";

export const showMinModulesPowerAlert = (functionOnclose?: Function, functionOnConfirmation?: Function) => {
  confirmationDialog.setup({
    onlyConfirm: true,
    content: [
      `A potência total de módulos deve ser no mínimo ${percentualPotenciaMinimoModulos}% do somatório da potência máxima CC dos inversores.`,
      <br/>,
      <br/>,
      'Exemplo:',
      <br/>,
      `Inversor de 10 kW: Potência máxima de entrada CC = 15 kWp → ${percentualPotenciaMinimoModulos}% x 15 kWp = 1,95kWp → Potência total de módulos mínima aceitável.`,
      <br/>,
      <br/>,
      'Sugestões:',
      <ul>
        <li>Altere a quantidade de módulos; ou</li>
        <li>Altere o modelo e/ou quantidade do inversor;</li>
      </ul>
    ],
    size: isMobile() ? 'auto' : '440px',
    title: "Atenção!",
    yesText: 'OK',
    propagateWhenConfirm: true,
    subtitle: <span>Quantidade <strong>mínima</strong> de inversores</span>,
    onClose: () => {
      if(functionOnclose) functionOnclose();
      confirmationDialog.close();
    },
    onConfirmation: () => {
      if(functionOnConfirmation) functionOnConfirmation();
    },
    headerIcon: <Error style={{ color: '#CC8F00' }} />, 
    className: 'show-min-modules-power-alert'
  })
  confirmationDialog.open();
}